var $3b9721aaf64cd522$exports = {};
$3b9721aaf64cd522$exports = {
    "help": `Hilfe`,
    "info": `Informationen`
};


export {$3b9721aaf64cd522$exports as default};
//# sourceMappingURL=de-DE.mjs.map
